import { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Skeleton, Alert } from "@mui/material";
import { report } from "../../features/reports/reportsSlice";
import { TitleWSelect } from "../Tools";
import { getYears } from "../Tools/functions";

const ReportSeven = () => {
    const { isLoading } = useSelector(state => state.progress);
    const [data, setData] = useState([])
    const [status, setStatus] = useState('idle');
    const [year, setYear] = useState('');
    const options = useMemo(() => getYears(), [])
    const dispatch = useDispatch();
    const headers = ['Carrera', '1 - 3', '4 - 6', '7 - 10', ' + de 10', 'Total']

    const handleChange = (e) => {
        setYear(e.target.value)
        if(e.target.value !== ''){
            report(`seven/year/${e.target.value}`, dispatch, setData, setStatus)
        }else{
            setStatus('idle')
            setData([]);
        }
    }
    
    return(
        <Container component={Paper} sx={{ p: '2em', mb: '2em' }} maxWidth='xl'>
            <TitleWSelect title={'EVENTOS POR ALUMNO'} handleChange={handleChange} options={options} year={year} />
            { isLoading ? <Skeleton animation='wave' height={200} /> : ( data.length ? (
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={1}></TableCell>
                                    <TableCell colSpan={5} sx={{ backgroundColor: 'lightgray', fontWeight: 'bolder' }} align="center">Participación en actividades por rango</TableCell>
                                </TableRow>
                                <TableRow>
                                    { headers.map((h, i) => <TableCell key={i} align="center">{h}</TableCell>) }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { data.map(({ nombre, one, two, three, four, total }, i) => (
                                    <TableRow key={i}>
                                        <TableCell>{nombre}</TableCell>
                                        <TableCell align="center">{one}</TableCell>
                                        <TableCell align="center">{two}</TableCell>
                                        <TableCell align="center">{three}</TableCell>
                                        <TableCell align="center">{four}</TableCell>
                                        <TableCell align="center"><b>{total}</b></TableCell>
                                    </TableRow>
                                )) }
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : status === 'succeeded' ? <Alert severity="waring">No se encontraron resultado</Alert> : null
            )}
        </Container>
    )
}

export default ReportSeven;